import * as React from 'react';
import { getIsBot } from '@/redux/modules/analytics';
import { getSailthruCustomerId } from '@/redux/modules/config';
import { useSelector } from 'react-redux';

const SailthruInit = () => {
    const customerId = useSelector(getSailthruCustomerId);
    const isBot = useSelector(getIsBot);
    React.useEffect(() => {
        // @ts-ignore
        if (!isBot && window.Sailthru && window.Sailthru.init && !window.Sailthru.initRan) {
            // @ts-ignore
            window.Sailthru.init({
                autoTrackPageview: false,
                customerId,
                isCustom: true,
                useStoredTags: true,
            });
            // @ts-ignore
            window.Sailthru.initRan = true;
        }
    }, []); // eslint-disable-line
    return null;
};

export default SailthruInit;
